module.exports = function(service) {
	'use strict'
	service.factory('createRandomHash', createRandomHash);
	createRandomHash.$inject = [];
	function createRandomHash() {
	   return function(length) {
			var result           = '';
		   	var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		   	var charactersLength = characters.length;
		   	for ( var i = 0; i < length; i++ ) {
		      result += characters.charAt(Math.floor(Math.random() * charactersLength));
		   	}
		   	return result;
	   }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/createRandomHashService.js
// module id = 593
// module chunks = 0